import { VF_BUTTON_SELECTOR } from 'AppSrc/core/components/forms/form-base-components/v-f-button-selector';
import {
  INLINE_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';
// import {
//   r12Yes,
//   r12No,
// } from 'AppSrc/core/components/forms/value-dependency-constants';
// import { changeImpactTechnologyRecoverPlanId } from './section-two-constants';

const fieldId = 'technology-plan-required-fixed';

const validator = (params) => {
  const {
    values,
    field,
  } = params;
  const {
    optional,
  } = field;

  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();

  /* ERROR CHECKERS */
  const noValue = commonValidation.noValue(values[fieldId], VF_BUTTON_SELECTOR);

  /* ADD ERRORS TO ERROR OBJECT */
  errors[INLINE_ERRORS].push((noValue && !optional) ? 'Please select an answer' : null);

  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};


const initialValues = [];

const vFParams = {
  multiSelect: false,
  fieldTitle: 'Does this change impact our Technology Recovery Plans?',
};

// const riskLevelParams = {
//   weight: 0.2,
//   score: {
//     [r12Yes]: 1,
//     [r12No]: 4,
//   },
// };

const changeImpactTechnologyRecoverPlanFixed = {
  id: fieldId,
  validator,
  initialValues,
  vFParams,
  // riskLevelParams,
  fieldType: VF_BUTTON_SELECTOR,
};

export { changeImpactTechnologyRecoverPlanFixed };
